import styled from "styled-components"
export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.amarillo};
  color: ${({ theme }) => theme.colors.azul};
  h2 {
    margin-top: 0;
    font-family: "aller";
    &::after {
      content: "";
      width: 100%;
      height: 3px;
      background-color: ${({ theme }) => theme.colors.azul};
      display: block;
    }
  }
`
